import { QueryClient } from "@tanstack/react-query";

/**
 * Global TanStack Query client.
 *
 * The defaults deliberately match the app's behavior from before TanStack
 * Query: no automatic retries, and no automatic refetching on window focus
 * or network reconnect (with `retry: false`, a single failed automatic
 * refetch would otherwise swap an already-rendered view for an error state).
 * With the default `staleTime: 0`, remounting a component shows cached data
 * instantly and refreshes it in the background.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
